import { NgClass } from '@angular/common';
import { Component, DOCUMENT, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ISideBar, ISideBarContent } from '../../../models/sideBar';
import { StateService } from '../../../services/state.service';

@Component({
  selector: 'app-side-bar',
  imports: [RouterLink, NgClass],
  templateUrl: './side-bar.html',
  styleUrl: './side-bar.scss',
})
export class SideBar {
  protected stateService = inject(StateService);
  private router = inject(Router);

  contents = input<ISideBarContent[]>([]);
  sidebarState = input<ISideBar>({});

  private auth = inject(AuthService);
  private doc = inject(DOCUMENT);

  handleLogout(): void {
    this.auth.logout({
      logoutParams: {
        returnTo: this.doc.location.origin,
      },
    });
  }

  public goToAdmin(): void {
    this.router.navigate(['/admin']);
  }
}
